import { ChangeDetectionStrategy, Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SzIconComponent } from '../../display/sz-icon';
import { SzTabBarItem } from './sz-tab-bar-item.type';

@Component({
  selector: 'sz-tab-bar',
  templateUrl: './sz-tab-bar.component.html',
  styleUrls: ['./sz-tab-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterLink, RouterLinkActive, SzIconComponent]
})
export class SzTabBarComponent {
  readonly items: InputSignal<ReadonlyArray<SzTabBarItem>> = input.required<ReadonlyArray<SzTabBarItem>>();
  readonly fabDisabled: InputSignal<boolean> = input<boolean>(false);
  readonly fabActive: InputSignal<boolean> = input<boolean>(false);
  readonly fabAriaLabel: InputSignal<string> = input<string>('Start session');

  @Output() readonly fab: EventEmitter<void> = new EventEmitter<void>();

  emitFab(): void {
    this.fab.emit();
  }
}
